export const COURSES_APPROVED_WITH_USER_REQ = "courseApprovedWithUserReq";
export const COURSES_APPROVED_WITH_USER_SUCCESS =
  "courseApprovedWithUserSuccess";
export const COURSES_APPROVED_WITH_USER_FAIL = "courseApprovedWithUserFail";
